import * as d3 from "d3";
import hljs from "highlightjs";
import { cleanSvg } from "./cleanSvg";
import { generateSVGShadow } from "./generateSVGShadow";
import { getTransformFromViewBox } from "./getTransformFromViewBox";
import { MainMenu } from "./MainMenu";
var format = require("xml-formatter");
var svgpath = require("svgpath");
var fileSaver = require('file-saver');
var spectrum = require('spectrum-colorpicker');
var $ = require("jquery");
var currentAngle = 3 * Math.PI / 4;
var shadowGenOptions = {
    'background-circle': undefined,
    'shadow-path': undefined
};
var currentOp;
//selection of base image
var baseSvg = d3.select(".imageEntry").select("#scene");
//Generation of operation menu
var menu = new MainMenu();
var selectedPaths = [];
var dragOp = false;
var requestRefresh = false;
var refreshSvg = function (angle, options) {
    //Full reset of content
    baseSvg.selectAll("*").remove();
    var allPaths = [];
    //Injection of all pathes into the image
    $(".path-entry").each(function (index, element) {
        var newPath = baseSvg
            .append("path")
            .attr("clip-path", "url(#background-clip)");
        allPaths.push(newPath);
        for (var attr in $(element).data()) {
            if (attr !== "xmlns") {
                newPath.attr(attr, $(element).data(attr));
            }
        }
        newPath.attr("data-id", $(element).attr("data-id"));
        newPath.classed('active', $(element).hasClass('active'));
        newPath.on("click", function () {
            if (currentOp === 'select' || currentOp === 'paint') {
                $(".blooming-menu__container").trigger("path:selected", [newPath]);
                if (currentOp === "select") {
                    refreshSvg(currentAngle, options);
                }
            }
        });
    });
    generateSVGShadow(baseSvg, angle, options);
    var computeDistance = function (p1, p2) {
        return Math.sqrt(Math.pow((p1.x - p2.x), 2) + Math.pow((p1.y - p2.y), 2));
    };
    baseSvg.call(d3
        .drag()
        .on('start', function () {
        dragOp = true;
        if (currentOp === 'select' || currentOp === 'rotate' || currentOp === 'scale') {
            baseSvg.select('path[data-id=shadow-path]').remove();
        }
    })
        .on('drag', function () {
        if (dragOp) {
            $('.path-entry.active').each(function (index, item) {
                var curItem = $(this);
                var curPath = curItem.data('d');
                var pathId = curItem.data('id');
                var newPathData;
                var centroid = { x: 0, y: 0 };
                baseSvg.select('path[data-id=' + pathId + ']').each(function (d, i, array) {
                    var bbox = array[i].getBBox();
                    centroid = { x: bbox.x + bbox.width / 2, y: bbox.y + bbox.height / 2 };
                });
                if (currentOp === 'scale' && d3.event.dx !== 0) {
                    var scaleValue = void 0;
                    if (d3.event.dx > 0) {
                        scaleValue = 1.1;
                    }
                    else {
                        scaleValue = 0.9;
                    }
                    newPathData = svgpath(curPath)
                        .translate(-centroid.x, -centroid.y)
                        .scale(scaleValue)
                        .translate(centroid.x, centroid.y)
                        .toString();
                }
                else if (currentOp === 'select') {
                    newPathData = svgpath(curPath).translate(d3.event.dx, d3.event.dy).toString();
                }
                else if (currentOp === 'rotate') {
                    var previousCoords = { x: d3.event.x - d3.event.dx, y: d3.event.y - d3.event.dy };
                    var newCoords = { x: d3.event.x, y: d3.event.y };
                    var newAngle = -Math.round(Math.acos(computeDistance(newCoords, previousCoords) / computeDistance(newCoords, centroid)));
                    newPathData = svgpath(curPath).rotate(newAngle, centroid.x, centroid.y).toString();
                }
                if (newPathData !== undefined) {
                    curItem.empty();
                    curItem.data('d', newPathData);
                    curItem.empty();
                    var newCode = $("<code></code>")
                        .addClass("xml")
                        .appendTo(curItem);
                    newCode.text(buildDisplayFromData(curItem));
                    hljs.highlightBlock(newCode[0]);
                    baseSvg.select('path[data-id=' + pathId + ']').attr('d', newPathData);
                    requestRefresh = true;
                }
            });
        }
    })
        .on('end', function () {
        dragOp = false;
        if (requestRefresh) {
            refreshSvg(currentAngle, options);
            requestRefresh = false;
        }
    }));
    return allPaths;
};
var deselectAll = function () {
    $('#scene').trigger('path:deselect-all');
};
var buildDisplayFromData = function (node) {
    var text = "<path ";
    for (var attr in node.data()) {
        if (attr !== "xmlns" && attr !== 'id') {
            text += attr + '="' + node.data(attr) + '" ';
        }
    }
    text += "/>";
    return text;
};
var buildPathesWithTransform = function (rootNode, transform) {
    var allPaths = rootNode.querySelectorAll("path");
    var lastNumber;
    var lastId = $(".path-entry:last-child").attr('data-id');
    if (lastId !== undefined) {
        lastNumber = parseInt(lastId.split("-")[1]);
    }
    else {
        lastNumber = 0;
    }
    for (var i = 0; i < allPaths.length; i++) {
        var fetchedPath = allPaths[i];
        var newPathHolder = $("<pre></pre>")
            .appendTo("#path-container")
            .addClass("path-entry");
        var newCode = $("<code></code>")
            .appendTo(newPathHolder)
            .addClass("xml");
        var uniqueId = "path-" + (lastNumber + i + 1);
        newPathHolder.attr("data-id", uniqueId);
        for (var j = 0; j < fetchedPath.attributes.length; j++) {
            var attribute = fetchedPath.attributes[j];
            if (attribute.name == "d") {
                attribute.value = svgpath(attribute.value)
                    .translate(transform.tx + 250, transform.ty + 250)
                    .scale(transform.sx, transform.sy)
                    .scale(0.5)
                    .toString();
            }
            newPathHolder.attr("data-" + attribute.name, attribute.value);
        }
        newCode.text(buildDisplayFromData(newPathHolder));
        hljs.highlightBlock(newCode[0]);
    }
    return $(".path-entry");
};
var displayPainterOnObject = function (pathId) {
    //Updating picker color based on picker selection and displaying it
    var fill;
    currentlyColoredPath = $('.path-entry[data-id=' + pathId + ']');
    currentlyColorD3Path = baseSvg.select('[data-id=' + pathId + ']');
    if (currentlyColoredPath.length > 0 && currentlyColoredPath.data('fill') !== undefined) {
        fill = currentlyColoredPath.data('fill');
    }
    else {
        fill = currentlyColorD3Path.attr('fill');
        if (fill) {
            shadowGenOptions[pathId] = fill;
        }
        else {
            shadowGenOptions[pathId] = undefined;
        }
    }
    if (fill !== undefined) {
        $("#color-picker").spectrum("set", fill);
    }
    $("#color-picker").spectrum("show");
    //Preventing the click event from triggering anything else
    d3.event.stopPropagation();
    //Moving the color picker on the mouse selection point
    $('.sp-container').css({
        top: d3.event.y,
        left: d3.event.x
    });
};
var firstTimeBind = true;
var receivedText = function () {
    //menu won't initialize twice
    menu.setupMenu();
    //files should have a mime type followed by base64,
    cleanSvg(reader.result).then(function (result) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(result.data, "application/xml");
        var rootNode = doc.rootElement;
        if (rootNode.tagName !== "svg") {
            alert("The provided file is not an svg");
        }
        var t = getTransformFromViewBox(rootNode);
        var paths = buildPathesWithTransform(rootNode, t);
        refreshSvg(currentAngle, shadowGenOptions);
        paths
            .find(".path-selection")
            .off("change")
            .on("change", function (event) {
            var currentEl = $(event.currentTarget);
            var changing = currentEl.data("id");
            var checked = currentEl.is(":checked");
            currentEl.closest(".path-entry").toggleClass("active");
            var correspondingPath = baseSvg.select("#" + changing);
            correspondingPath.classed("active", checked);
        });
    });
    if (firstTimeBind) {
        $('.no-image').removeClass('no-image');
        $(".blooming-menu__container").on("path:selected", function (event, path) {
            var eventPathId = path.attr("id");
            if (currentOp === 'select') {
                var foundIdx = void 0;
                for (var index in selectedPaths) {
                    var curPath = selectedPaths[index];
                    if (curPath === eventPathId) {
                        foundIdx = index;
                    }
                }
                $('.path-entry[data-id=' + path.attr("id") + ']').toggleClass('active');
                if (foundIdx === undefined) {
                    selectedPaths.push(eventPathId);
                    d3.selectAll('path[data-id=' + eventPathId + ']').classed('active', true);
                }
                else {
                    d3.selectAll('path[data-id=' + eventPathId + ']').classed('active', false);
                    selectedPaths.splice(foundIdx, 1);
                }
                menu.enablePathOperations(selectedPaths.length > 0);
            }
            else if (currentOp === 'paint') {
                displayPainterOnObject(path.attr("id"));
            }
        });
        $(".blooming-menu__container").on("light", function () {
            deselectAll();
            currentOp = "light";
            $("#light-setup").show();
            $("#light-setup").animate({
                opacity: 1
            });
        });
        $(".blooming-menu__container").on("select", function () {
            currentOp = "select";
            $("#light-setup").animate({
                opacity: 0
            }, {
                complete: function () {
                    $("#light-setup").hide();
                }
            });
        });
        $(".blooming-menu__container").on("move", function () {
            currentOp = "move";
        });
        $(".blooming-menu__container").on("rotate", function () {
            currentOp = "rotate";
        });
        $(".blooming-menu__container").on("scale", function () {
            currentOp = "scale";
        });
        $(".blooming-menu__container").on("paint", function () {
            deselectAll();
            currentOp = 'paint';
            //Picker mode that will allow to paint elements on click
        });
        $(".blooming-menu__container").on("download", function () {
            deselectAll();
            //fetch the svg scene and download it as an image
            baseSvg.attr('xmlns', 'http://www.w3.org/2000/svg');
            var rawdata = $('#scene')[0].outerHTML;
            var blob = new Blob([rawdata], { type: "text/plain;charset=utf-8" });
            fileSaver.saveAs(blob, 'material-' + new Date().getTime() + '.svg');
        });
        firstTimeBind = false;
        currentOp = "select";
        $('#scene').on('path:deselect-all', function () {
            for (var pathId in selectedPaths) {
                var targetPath = d3.selectAll('path[data-id=' + selectedPaths[pathId] + ']');
                $(".blooming-menu__container").trigger("path:selected", [targetPath]);
            }
            refreshSvg(currentAngle, shadowGenOptions);
        });
        $('#scene').on('path:background-select', function (event, backgroundEl, backgroundType) {
            if (currentOp === 'select') {
                deselectAll();
            }
            else if (currentOp === 'paint') {
                displayPainterOnObject(backgroundEl.attr('data-id'));
            }
        });
    }
};
var reader = new FileReader();
reader.onload = receivedText;
var lightSvg = d3.select(".imageEntry").select("#light-setup");
var lightEl = lightSvg.select("#light-spawn");
var dragstarted = function (d) {
    d3
        .select(this)
        .raise()
        .classed("active", true);
};
var moveLight = function (rad) {
    var transformValue = "translate(" +
        (Math.cos(rad) * 275 + 300) +
        "," +
        (-Math.sin(rad) * 275 + 300) +
        ")";
    lightEl.attr("transform", transformValue);
};
var dragged = function (d) {
    var deltaX = d3.event.x - 300;
    var deltaY = d3.event.y - 300;
    var rad = -Math.atan2(deltaY, deltaX);
    currentAngle = rad;
    moveLight(rad);
    refreshSvg(rad, shadowGenOptions);
};
var dragended = function (d) {
    d3.select(this).classed("active", false);
};
var dragBehavior = d3
    .drag()
    .on("start", dragstarted)
    .on("drag", dragged)
    .on("end", dragended);
lightEl.call(dragBehavior);
moveLight(currentAngle);
$("html").on("dragover", function (event) {
    event.preventDefault();
    event.stopPropagation();
});
$("html").on("dragleave", function (event) {
    event.preventDefault();
    event.stopPropagation();
});
$("html").on("drop", function (e) {
    if (e.originalEvent.dataTransfer) {
        if (e.originalEvent.dataTransfer.files.length) {
            e.preventDefault();
            e.stopPropagation();
            reader.readAsText(e.originalEvent.dataTransfer.files[0]);
        }
    }
});
//Initialization of the painter
$("#color-picker").spectrum({
    showInput: true,
    showButtons: false,
    preferredFormat: 'hex',
});
var currentlyColoredPath;
var currentlyColorD3Path;
$("#color-picker").on('move.spectrum change.spectrum', function (e, tinycolor) {
    if (currentlyColoredPath.length !== undefined && currentlyColoredPath.length > 0) {
        //this is a known path
        currentlyColoredPath.data('fill', tinycolor);
    }
    else {
        //this is a pure system generated entry, we directly set the color on it
        shadowGenOptions[currentlyColorD3Path.attr('data-id')] = tinycolor;
    }
    refreshSvg(currentAngle, shadowGenOptions);
});
